import styles from './styles.module.css';
import { useSelector } from 'react-redux';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

export default  function AvailableUser() {
    //@ts-ignore
    const status = useSelector( (state) => state?.general?.user?.status);
    const unavailableMessage = useGlotaT('spa.chat.unavailableMessage');
    
    return (
        status !== 1 && (
            <div className={styles.offline_user}>
                {unavailableMessage}
            </div>
        )
    )
}